/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import _ from 'lodash';

import { ActiveAuth } from '@tock/logging';
import { RoleType, core, safeIncludesEnum } from '@tock/coretypes';
import protos from 'utils/protos';

const { BusinessRoles, GlobalRoles } = protos;

interface RoleTypeOption {
  key: string;
  label: string;
  value: string;
}

const RoleTypeOptions: RoleTypeOption[] = [
  { key: RoleType[RoleType.ADMIN], label: 'Administrator', value: RoleType[RoleType.ADMIN] },
  { key: RoleType[RoleType.EMPLOYEE], label: 'Employee', value: RoleType[RoleType.EMPLOYEE] },
  { key: RoleType[RoleType.HOST], label: 'Host', value: RoleType[RoleType.HOST] },
  { key: RoleType[RoleType.DRIVER], label: 'Driver', value: RoleType[RoleType.DRIVER] },
];

const AccountOwnerRoleTypeOptions: RoleTypeOption[] = [
  {
    key: RoleType[RoleType.ACCOUNT_OWNER],
    label: 'Account Owner',
    value: RoleType[RoleType.ACCOUNT_OWNER],
  },
];

export interface PatronRoleInfo {
  isBusinessAccountOwner: boolean;
  isEngOrHospitality: boolean;
}

export function canManageAccountOwners(patronRoleInfo: PatronRoleInfo): boolean {
  const { isBusinessAccountOwner, isEngOrHospitality } = patronRoleInfo;
  return isBusinessAccountOwner || isEngOrHospitality;
}

export function getRoleOptions(
  patronRoleInfo: PatronRoleInfo,
  currentValue?: RoleType
): SelectOption[] {
  return _getRoleOptions(patronRoleInfo, currentValue);
}

function _getRoleOptions(patronRoleInfo: PatronRoleInfo, currentValue?: RoleType): SelectOption[] {
  if (!canManageAccountOwners(patronRoleInfo) && currentValue !== RoleType.ACCOUNT_OWNER) {
    return RoleTypeOptions;
  }
  return _.concat(AccountOwnerRoleTypeOptions, RoleTypeOptions);
}

export function getRoleType(
  globalRoles: core.GlobalRoles.Role[],
  businessRoles: core.BusinessRoles.Role[]
): RoleType {
  if (safeIncludesEnum(globalRoles, GlobalRoles.Role, GlobalRoles.Role.ENG)) {
    return RoleType.ENG;
  } else if (safeIncludesEnum(globalRoles, GlobalRoles.Role, GlobalRoles.Role.FINANCE)) {
    return RoleType.FINANCE;
  } else if (safeIncludesEnum(globalRoles, GlobalRoles.Role, GlobalRoles.Role.HOSPITALITY)) {
    return RoleType.HOSPITALITY;
  } else if (
    safeIncludesEnum(businessRoles, BusinessRoles.Role, BusinessRoles.Role.ACCOUNT_OWNER)
  ) {
    return RoleType.ACCOUNT_OWNER;
  } else if (safeIncludesEnum(businessRoles, BusinessRoles.Role, BusinessRoles.Role.ADMIN)) {
    return RoleType.ADMIN;
  } else if (safeIncludesEnum(businessRoles, BusinessRoles.Role, BusinessRoles.Role.EMPLOYEE)) {
    return RoleType.EMPLOYEE;
  }
  return RoleType.HOST;
}

export function hasRole(activeAuth: ActiveAuth | undefined, roleTypes: RoleType[]): boolean {
  return !!activeAuth && _.includes(roleTypes, activeAuth.roleType);
}

/**
 * Identify e2e (Selenium) test user accounts
 */
export const isE2ETestUser = (email: string) => /^test.*@tockhq.com$/.test(email);
